import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  rootPopover: {
    position: "fixed",
    marginTop: "12px !important"
  },
  rootPopoverBack: {
    width: "100%"
  },
  warningButton: {
    minWidth: 22,
    padding: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 2,
    backgroundColor: "transparent",
    border: `1px dashed ${theme.palette.primary.light}`,
    "& $warningButtonIcon": {
      color: theme.palette.text.hint
    },
    "&:hover": {
      cursor: "pointer"
    }
  },
  warningButtonActive: {
    backgroundColor: "#ff7e02",
    border: "1px solid transparent",
    "& $warningButtonIcon": {
      color: theme.palette.common.white
    },
    "& $warningButtonText": {
      color: theme.palette.common.white
    }
  },
  warningButtonIcon: {
    fontSize: 14,
    color: "#797979",
    [theme.breakpoints.down("xs")]: {
      fontSize: 14
    }
  },
  warningButtonText: {},
  warnDialog: {},
  warnDialogPaper: {
    minWidth: 340,
    maxWidth: 340
  },
  warnDialogTitle: {
    fontSize: 16,
    fontWeight: 600,
    padding: "12px 16px"
  },
  borderBottom: {
    borderBottom: "1px solid #eeeeee"
  },
  warnDialogContent: {
    padding: "12px 16px"
  },
  viewMode: {},
  editMode: {},
  warnContent: {
    position: "relative"
  },
  warnContentBody: {},
  loadingOverlay: {
    position: "absolute",
    backgroundColor: "white",
    opacity: 0.4,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1
  },
  infoBlock: {
    padding: "8px 0",
    wordWrap: "break-word"
  },
  infoBlockTitle: {
    fontSize: 12,
    color: theme.palette.text.secondary
  },
  infoBlockData: {
    lineHeight: 1.2
  },
  infoBlockAdditional: {
    fontSize: 12,
    color: theme.palette.text.secondary
  },
  inputMessageContainer: {
    position: "relative"
  },
  customTextArea: {
    "& .MuiOutlinedInput-root": {
      borderColor: theme.palette.secondary.dark,
      borderWidth: 1,
      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: theme.palette.secondary.dark,
          borderWidth: 1
        }
      }
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.secondary.dark
    },
    "& .MuiFormLabel-root": {
      color: theme.palette.secondary.dark
    },
    "&:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.secondary.dark
      }
    },
    "&:focus": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.secondary.dark
      }
    },
    "&.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.secondary.dark,
        borderWidth: 1
      }
    }
  },
  customTextAreaRoot: {},
  textCounter: {
    position: "absolute",
    right: 12,
    bottom: -7,
    fontSize: 10,
    backgroundColor: theme.palette.common.white,
    padding: "0 4px",
    color: theme.palette.text.hint
  },
  warnContentFooter: {
    display: "flex",
    marginTop: 20
  },
  footerPart: {
    flex: "1 0 50%",
    display: "flex",
    justifyContent: "space-between",
    "&.leftPart": {},
    "&.rightPart": {
      flexDirection: "row-reverse"
    }
  },
  warnButton: {
    fontSize: 16,
    letterSpacing: 0.5,
    color: theme.palette.text.secondary,
    "&.remove": {
      color: "#f73d54"
    },
    "&.edit": {},
    "&.cancel": {},
    "&.save": {
      color: theme.palette.secondary.dark
    },
    "&.Mui-disabled": {
      opacity: 0.5
    }
  }
}));
